import React, { useState } from 'react';
import { Card, Button, Row, Col, Modal, Table } from 'antd';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import './CardNav.css';
import UpgradeToBusinessModal from '../../Management/UpgradeToBusinessModal';
import { getFreeStatus } from '../../Common';
import { track } from 'statsig'
import { STATSIG, PAGE } from 'statsig/events'

// 定义Redux store的类型
interface RootState {
    subscriptionReducer: {
        currentInfo: {
            plan?: string;
            loanOfficers?: any[];
        };
    };
}

const CardNav: React.FC<{items: any[], statsigSource?: string}> = ({items, statsigSource}) => {
    const history = useHistory();
    const [showUpgradeModal, setShowUpgradeModal] = useState(false);
    
    // 从Redux store获取订阅信息
    const subscriptionReducer = useSelector(
        (state: RootState) => state.subscriptionReducer?.currentInfo
    );

    // 判断当前用户是否为free plan
    const isFreePlan = getFreeStatus(
        subscriptionReducer?.plan,
        subscriptionReducer?.loanOfficers
    );

    const growthHubItemValue = (key: string) => {
        if (key === 'landingpage') return PAGE.PERSONAL_SITE_BLUERATE
        if (key === 'openhousefinder') return PAGE.OPEN_HOUSE_FINDER
        return key
    }

    const handleCardClick = (item: any) => {
        // 如果是free plan且点击的是openhousefinder，显示升级弹窗
        if (isFreePlan && item.key === 'openhousefinder') {
            if (statsigSource === 'growth_hub') {
                const itemValue = growthHubItemValue(item.key)
                track(STATSIG.GROWTH_HUB.UPGRADE_BLOCK, itemValue, { item: itemValue })
            }
            setShowUpgradeModal(true);
            return;
        }

        if (statsigSource === 'growth_hub') {
            const itemValue = growthHubItemValue(item.key)
            track(STATSIG.GROWTH_HUB.ITEM_CLICK, itemValue, { item: itemValue })
        }
        // 正常跳转
        history.push(item.link);
    };

    const handleUpgrade = () => {
        if (statsigSource === 'growth_hub') {
            track(STATSIG.GROWTH_HUB.UPGRADE, 'individual', { plan: 'individual' })
        }
        setShowUpgradeModal(false);
        // 跳转到定价页面
        sessionStorage.setItem('path', 'Pricing');
        window.open('/app/management', '_self');
    };

    return (
        <>
            <div className='cardnav-panel'>
                {items.map((item) => (
                    <Card 
                        className='cardnav-card'
                        key={item.key}
                        hoverable
                        cover={<img alt={item.title} src={`/images/${item.image}`} />}
                        onClick={() => handleCardClick(item)}
                    >
                        <Card.Meta title={item.title} description={item.description} />
                    </Card>
                ))}
            </div>
            
            {/* 升级到Individual弹窗 */}
            <UpgradeToBusinessModal
                isOpen={showUpgradeModal}
                onClose={() => setShowUpgradeModal(false)}
                onUpgrade={handleUpgrade}
                onViewPlanDetail={() => {}}
                upgradeTo="individual"
            />
        </>
    )
}

export default CardNav;
